<template>
  <div class="p_demand_content">
    <div class="topOperation">
        <div class="top-left">
            <div><ShowNavHead/></div>
        </div>
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>雇员</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/recruitDemand' }">招聘需求</el-breadcrumb-item>
                <el-breadcrumb-item>{{pageTitle}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
      <div class="p_demand_box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="岗位信息" name="first"></el-tab-pane>
            <el-tab-pane label="招聘计划" name="second"></el-tab-pane>
        </el-tabs>
        <div class="p_demands">
          <recruitInfoRead v-if="activeName=='first'"/>
          <RecruitPlanDetail v-if="activeName == 'second'"></RecruitPlanDetail>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RecruitPlanDetail from "./components/recruitPlanDetail.vue"
import recruitInfoRead from "./components/recruitInfoRead.vue"
export default {
   components: {
    recruitInfoRead,
    RecruitPlanDetail
  },
  name: "demandUpdate",
  data() {
    return {
        isDetail:false,
        pageTitle:'岗位信息查看',
        activeName:'first'
    }
  },
  created() {
    
  },
  methods: {
    handleClick(tab, event) {
        console.log(tab, event);
        if(tab.name == 'first'){
            this.pageTitle = '岗位信息查看'
        }else{
            this.pageTitle = '招聘需求查看'
        }
    }
  }
}
</script>
<style>

</style>
<style scoped>
.p_demand_box{
    padding: 10px 20px;
    background-color: #fff;
}
</style>